import React from 'react';
import classnames from 'classnames';
import s from './Badge.scss';
const Badge = ({ badge , size =24 , type ='normal' , className  })=>{
    var _assets_compositeKey;
    const { title: badgeTitle , description , stackCount , assets  } = badge;
    let title = badgeTitle;
    if (description) {
        title += `: ${description}`;
    }
    if (stackCount) {
        title += ` (${stackCount})`;
    }
    const compositeKey = type === 'normal' ? 'normalComposite' : 'hugeComposite';
    const images = (assets === null || assets === void 0 ? void 0 : assets[compositeKey]) ? (_assets_compositeKey = assets[compositeKey]) === null || _assets_compositeKey === void 0 ? void 0 : _assets_compositeKey.map((i)=>i.imageUrl) : [
        assets === null || assets === void 0 ? void 0 : assets[type]
    ];
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s[`size-${size}`], className),
        title: title
    }, images === null || images === void 0 ? void 0 : images.filter((i)=>i).map((image)=>/*#__PURE__*/ React.createElement("img", {
            key: image,
            src: image,
            className: s['image'],
            alt: title,
            loading: "lazy"
        })));
};
Badge.displayName = 'Badge';
export default Badge;
